/**
 * @file confirm in vue version
 */

import  { messageBox } from '@/ui';

export default (options: {
  title: string;
  msg: string;
  confirmText: string;
  cancelText: string;
  confirm: () => void;
  cancel: () => void;
}): Promise<void> => {
  const { title, msg: message, confirmText: confirmButtonText, cancelText: cancelButtonText } = options;

  const boxOptions: Record<string, any> = {
    showCancelButton: true,
    title,
    message,
    confirmButtonText,
    cancelButtonText,
  };

  return messageBox(boxOptions).then((action: string) => {
    if (action === 'confirm') {
      options.confirm();
    } else if (options.cancel) {
      options.cancel();
    }
  });
};
